<template>
	<div class="rootDiv">
		<div class="retrieve">
			<div class="searchDiv">
				<div class="flex flex-ac flex-jb">
					<div class="flex flex-ac">
						<span class="fs-16 flex1">系列名称：</span>
						<el-select v-model="seriesId" class="w-150" filterable placeholder="请选择" @change="handleSeriesChang"
							clearable>
							<el-option v-for="item in seriesList" :key="item.id" :label="item.seriesName" :value="item.id">
							</el-option>
						</el-select>
					</div>
					<div class="flex flex-ac ml-20">
						<span class="fs-16 flex1">套数：</span>
						<el-select v-model="retrieveForm.page" class="w-100" filterable placeholder="请选择" clearable>
							<el-option v-for="item,index in totalPage" :key="index" :label="index+1" :value="index+1">
							</el-option>
						</el-select>
					</div>
					<div class="flex flex-ac ml-20">
						<span class="fs-16 flex1">商品名称：</span>
						<!-- <el-input class="w-150" v-model="retrieveForm.detailsName" clearable></el-input> -->
						<el-select v-model="retrieveForm.detailsName" class="w-150" filterable placeholder="请选择" clearable>
							<el-option v-for="item in goodDetailsList" :key="item.id" :label="item.ductName" :value="item.ductName">
							</el-option>
						</el-select>
					</div>
					<div class="flex flex-ac ml-20">
						<span class="fs-16 flex1">用户名：</span>
						<el-input class="w-100" v-model="retrieveForm.userName" clearable></el-input>
					</div>
					<div class="flex flex-ac ml-20">
						<span class="fs-16 flex1">手机号：</span>
						<el-input class="w-100" v-model="retrieveForm.phone" clearable></el-input>
					</div>
					<div class="flex flex-ac">
						<span class="width-100 fs-16 flex1 ml-20">创建时间：</span>
						<el-date-picker class="w-250" v-model="startEndDate" type="daterange" valueFormat="yyyy-MM-dd"
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handPickerChange">
						</el-date-picker>
					</div>
					<div class="ml-40 fc-6b9eff fs-16 pointer" @click="exportExcel">
						<i class="el-icon-upload mr-10 fs-18"></i>导出
					</div>
					<div label="" class="mr-5" style="margin-left: auto;">
						<el-button type="primary" @click="submitSearch">查询</el-button>
					</div>
				</div>
			</div>
		</div>
		<TableHeightFull class="tableDiv pall-30">
			<EleTable ref="tableRef" slot="table" :tableData="tableData" :columns="columns" height="100%" :border="false"
				v-loading="tabLoading" :row-style="{ cursor: 'pointer' }">
				<!-- 				<template v-slot:img="scope">
					<img :src="scope.row.coverImg" alt="" class="smallImg" v-if="scope.row.coverImg">
				</template> -->
			</EleTable>
			<PagingComponent slot="after" :page-info="pageInfo" @getTableData="getTableData" />
		</TableHeightFull>
	</div>
</template>

<script>
	import indexMixin from "@/utils/indexMixin"
	export default {
		name: 'rewardRecord',
		mixins: [indexMixin],
		components: {
			"EleTable": (resolve) => require(["@/components/public/TSimpleTable"], resolve),
			"TableHeightFull": (resolve) => require(["@/components/public/TableHeightFull"], resolve),
			"PagingComponent": (resolve) => require(["@/components/public/PagingComponent"], resolve),
		},
		data() {
			return {
				tabLoading: false,
				tableData: [],
				seriesList: [], //系列列表
				goodDetailsList: [], //商品列表
				seriesId: '',
				totalPage: '',
				startEndDate: [], //时间区间
				retrieveForm: {
					userName: '',
					phone: '',
					seriesName: '',
					detailsName: '',
					page: '',
					startDate: '',
					endDate: ''
				},
				columns: [{
					type: 'index',
					label: '序号',
					width: '60',
					align: 'center',
					fixed: 'left',
					index: this.indexMethod
				}, {
					label: '用户名',
					align: 'center',
					fixed: 'left',
					prop: 'userName',
				}, {
					label: '手机号',
					align: 'center',
					fixed: 'left',
					prop: 'phone',
				}, {
					label: '系列名称',
					align: 'center',
					fixed: 'left',
					prop: 'seriesName',
				}, {
					label: '商品名称',
					align: 'center',
					fixed: 'left',
					prop: 'detailsName',
				}, {
					label: '套数',
					align: 'center',
					fixed: 'left',
					prop: 'page',
				}, {
					label: '创建时间',
					align: 'center',
					fixed: 'left',
					prop: 'createDate',
				}, ]
			}
		},
		mounted() {
			this.finGoodSeriesAll()
		},
		methods: {
			submitSearch() {
				this.pageInfo.pageNum = 1
				this.getTableData()
			},
			//获取表格数据
			getTableData() {
				this.tabLoading = true
				this.$http.get('/goodAccount/findGoodAccountDateList', {
					params: {
						currentPage: this.pageInfo.pageNum,
						pageSize: this.pageInfo.pageSize,
						seriesGoodsType: 0,
						...this.retrieveForm,
					}
				}).then(({
					data: result
				}) => {
					this.tabLoading = false
					this.tableData = result.data.list
					this.pageInfo.total = result.data.total
				}).catch(err => {
					this.tabLoading = false
				})
			},
			// 查询所有一番赏数据
			finGoodSeriesAll() {
				this.$http.get('/goodSeries/finAllGoodSeries', {
					params: {
						goodSeriesType: 5
					}
				}).then((result) => {
					this.seriesList = result.data.data
				})
			},
			//选择系列
			handleSeriesChang(seriesId) {
				this.retrieveForm.detailsName = ''
				this.totalPage = ''
				if (!seriesId) {
					this.goodDetailsList = []
					return
				}
				this.$http.get('/goodSeries/finAllGoodSeries', {
					params: {
						goodSeriesType: 5,
						seriesId
					}
				}).then((result) => {
					this.goodDetailsList = result.data.data
					let seriesList = this.seriesList.filter(item => item.id === seriesId)
					this.retrieveForm.seriesName = seriesList[0].seriesName
					this.totalPage = seriesList[0].totalPage
				})
			},
			//时间变化
			handPickerChange(value) {
				if (value && value.length != 0) {
					this.retrieveForm.startDate = value[0]
					this.retrieveForm.endDate = value[1]
				} else {
					this.retrieveForm.startDate = ""
					this.retrieveForm.endDate = ""
				}
			},
			//导出
			exportExcel() {
				if (this.tableData.length > 0) {
					this.$http.get('/goodAccount/exceportGoodAccountList', {
						params:{
							...this.retrieveForm
						},
						responseType: "blob", // 1.首先设置responseType对象格式为 blob:
					}).then((result) => {
						debugger
						let blob = new Blob([result.data], {
							type: "application/vnd.ms-excel",
						})
						// 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
						let url = window.URL.createObjectURL(blob) // 3.创建一个临时的url指向blob对象
						// 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
						let a = document.createElement("a")
						a.href = url
						a.download = "抽赏记录.xls"
						a.click()
						// 5.释放这个临时的对象url
						window.URL.revokeObjectURL(url)
					}).catch((err) => {
						debugger
					})
				} else {
					this.$message({
						message:'请输入筛选条件'
					})
				}
			},
		}
	}
</script>

<style>
</style>